/* Scroll-triggered section color fade (ported from the design's section-colors.js).
   Sections carry data-bg / data-fg; the main content area fades to the colors of the section
   crossing the middle of the screen. Shopify wraps every section in its own element, so the
   color is applied to <main> instead of the sections' shared parent. */
(function () {
  if (window.__yuSecColors) return; window.__yuSecColors = true;
  var D = document, H = D.documentElement;
  if (H.dataset.scrollColors === 'off') return;
  var st = D.createElement('style');
  st.textContent =
    'section[data-bg]:not([data-bg-keep]) { background-color: transparent !important; }' +
    '#MainContent.yu-sc { background-color: var(--yu-bg) !important; color: var(--yu-fg) !important; }' +
    'html.yu-sc-ready #MainContent.yu-sc { transition: background-color 0.7s ease, color 0.7s ease; }' +
    '@media (prefers-reduced-motion: reduce) { #MainContent.yu-sc { transition: none !important; } }' +
    'html.yu-motion #MainContent.yu-sc { transition: none !important; }';
  var main = function () { return D.getElementById('MainContent'); };
  var set = function (s) { H.style.setProperty('--yu-bg', s.getAttribute('data-bg')); H.style.setProperty('--yu-fg', s.getAttribute('data-fg') || 'inherit'); };
  var seen = new WeakSet(), io = null, booted = false;
  var list = function () { return [].slice.call(D.querySelectorAll('#MainContent section[data-bg]:not([data-bg-keep])')); };
  var scan = function () {
    var secs = list(); if (!secs.length) return;
    if (!booted) {
      booted = true;
      var mid = innerHeight / 2;
      var first = secs.filter(function (s) { var r = s.getBoundingClientRect(); return r.top <= mid && r.bottom >= mid; })[0]
        || secs.filter(function (s) { return s.getBoundingClientRect().top > mid; })[0] || secs[secs.length - 1];
      set(first);
      D.head.appendChild(st);
      var m = main(); if (m) m.classList.add('yu-sc');
      requestAnimationFrame(function () { requestAnimationFrame(function () { H.classList.add('yu-sc-ready'); }); });
      if ('IntersectionObserver' in window) io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) set(e.target); }); }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
    }
    if (io) secs.forEach(function (s) { if (!seen.has(s)) { seen.add(s); io.observe(s); } });
  };
  var cur = null, raf = 0;
  var sync = function () { raf = 0; var mid = innerHeight / 2, secs = list(); for (var i = 0; i < secs.length; i++) { var r = secs[i].getBoundingClientRect(); if (r.top <= mid && r.bottom >= mid) { if (secs[i] !== cur) { cur = secs[i]; set(cur); } return; } } };
  addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
  addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(sync); });
  /* re-scan when the theme editor adds, moves or removes a section */
  D.addEventListener('shopify:section:load', function () { scan(); sync(); });
  D.addEventListener('shopify:section:reorder', function () { scan(); sync(); });
  var go = function () { scan(); sync(); };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', go); else go();
})();
